import ImportProcessDomainService from "../Domain/ImportProcess/ImportProcess.service";
import FetchService from "./Shared/FetchService";
const BASE_URL = "/aviso/importProcess";
export default class ImportProcessService {
    static search(search, options = {}) {
        return FetchService.getPagedResponse(BASE_URL + "/search", {
            ids: search.ids,
            titles: search.titles,
            minCreatedDate: search.minCreatedDate,
            maxCreatedDate: search.maxCreatedDate,
            createdByIds: search.createdByIds,
            statusIds: search.statusIds,
            importProcessHandlerIds: search.importProcessHandlerIds,
            query: search.query,
            max: options.max,
            offset: options.offset,
            sort: options.sort,
            order: options.order,
        }).then((resp) => {
            var _a;
            return (Object.assign(Object.assign({}, resp), { 
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                data: (_a = resp.data) === null || _a === void 0 ? void 0 : _a.map(ImportProcessDomainService.fromJSON) }));
        });
    }
    static isImportProcessFeatureEnabled() {
        return FetchService.getSingleResponse(BASE_URL + "/isImportProcessFeatureEnabled");
    }
}
